<template>
  <div class="round-button" @click.stop="btnclick" :style="{
    backgroundImage: `url(/static/${src}.png)`
  }"><slot></slot></div>
</template>

<style scoped>
  .round-button{
    width: 30px;
    height: 30px;
    background: white;
    border: 1px solid gray;
    color: gray;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
    border-radius: 16px;
    background-size: 70%;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>

<script>
export default {
  name: 'RoundButton',
  props: {
    src: String
  },
  methods: {
    btnclick (ev) {
      this.$emit('click', ev)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoundButton.vue